import { get } from '../client/axiosClient';
import { drillReportEndpoints } from '../endpoints/drillReport.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type { PaginatedResponse } from '../types';
import type { DrillQueryRequest, DrillRow, DrillSummary } from '../types/drillReport.types';

function toPaged<T>(raw: any): PaginatedResponse<T> {
  const pagedResult = raw?.data ?? {};
  return {
    success: raw?.success ?? false,
    message: raw?.message,
    data: pagedResult.items ?? [],
    pagination: {
      currentPage: pagedResult.page ?? 1,
      pageSize: pagedResult.pageSize ?? 25,
      totalPages: pagedResult.totalPages ?? 0,
      totalItems: pagedResult.totalCount ?? 0,
      hasNextPage: pagedResult.hasNext ?? false,
      hasPreviousPage: pagedResult.hasPrevious ?? false,
    },
  };
}

class DrillReportService {
  async getDrill(params?: DrillQueryRequest): Promise<PaginatedResponse<DrillRow>> {
    const endpoint = params
      ? buildEndpointWithQuery(drillReportEndpoints.drillPath(), params as Record<string, any>)
      : drillReportEndpoints.drill();
    const response = await get<any>(endpoint);
    return toPaged<DrillRow>(response.data);
  }

  async getDrillSummary(params?: DrillQueryRequest): Promise<DrillSummary> {
    const endpoint = params
      ? buildEndpointWithQuery(drillReportEndpoints.drillSummaryPath(), params as Record<string, any>)
      : drillReportEndpoints.drillSummary();
    const response = await get<any>(endpoint);
    return response.data?.data ?? {
      rowCount: 0, totalMinutes: 0, totalHours: 0,
      totalStandardAmount: 0, totalDiscountedAmount: 0, totalPremiumAmount: 0, entryCount: 0,
    };
  }

  async getDrillExport(params?: DrillQueryRequest, cap: number = 50000): Promise<DrillRow[]> {
    const queryParams = { ...(params || {}), cap } as Record<string, any>;
    const endpoint = buildEndpointWithQuery(drillReportEndpoints.drillExportPath(), queryParams);
    const response = await get<any>(endpoint);
    return response.data?.data ?? [];
  }
}

export const drillReportService = new DrillReportService();
export default drillReportService;
